import { TeamSide } from '@collector/shared-domain'
import { teamColors as _teamColors } from '@collector/shared-ui'

type Color = `${number}, ${number}, ${number}`

type TeamColorConfigRecord = Record<number, Color>

const teamColors: {
  home: TeamColorConfigRecord
  away: TeamColorConfigRecord
} = {
  home: transformColors(Object.values(_teamColors['team-home'])),
  away: transformColors(Object.values(_teamColors['team-away'])),
}

function transformColors(colors: string[]): TeamColorConfigRecord {
  return colors.reduce((acc, color, index) => {
    const transformedColor = color.slice(4, -1)
    acc[index] = transformedColor as Color

    return acc
  }, {} as TeamColorConfigRecord)
}

function setTeamColors(side: TeamSide, currentSideColor: TeamSide): void {
  for (let i = 0; i <= 10; i++) {
    const color = teamColors[currentSideColor][i]

    document.documentElement.style.setProperty(
      `--current-${side}-color-${i}`,
      color,
    )
  }
}

export function setTeamSidesColors(teamColorsSwitched: boolean): void {
  setTeamColors('home', teamColorsSwitched ? 'away' : 'home')
  setTeamColors('away', teamColorsSwitched ? 'home' : 'away')
}
